import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout, Menu, Button, Row, Col, Typography, Form, Input } from "antd";
// api
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
// const signup = [
//     <svg
//         data-v-4ebdc598=""
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//     >
//         <path
//             data-v-4ebdc598=""
//             fillRule="evenodd"
//             clipRule="evenodd"
//             d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
//             fill="#111827"
//             className="fill-muted"
//         ></path>
//     </svg>,
// ];

const signIn = [
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
    >
        <path
            className="fill-muted"
            d="M12.25,14H1.75A1.752,1.752,0,0,1,0,12.25V3.5A1.752,1.752,0,0,1,1.75,1.75h.876V.875a.875.875,0,0,1,1.75,0V1.75h5.25V.875a.875.875,0,0,1,1.75,0V1.75h.875A1.752,1.752,0,0,1,14,3.5v8.75A1.752,1.752,0,0,1,12.25,14ZM3.5,4.375a.875.875,0,0,0,0,1.75h7a.875.875,0,0,0,0-1.75Z"
        />
    </svg>,
];
function SignIn() {
    const navigate = useNavigate();
    const { Header, Content } = Layout;
    const { Title } = Typography;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    useEffect(
        function () {
            if (localStorage.getItem("user")) navigate("/geo");
        },
        [localStorage.getItem("user")]
    );

    const onFinish = (values) => {
        setEmail(values.email);
        setPassword(values.password);
        http.post(`${config.parkopoloApi}/api/User/`, {
            username: email,
            password: password,
        })
            .then((res) => {
                localStorage.setItem("user", res.data.token);
                toast.success("ورود موفقیت آمیز !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                navigate("/geo");
            })
            .catch((err) => {
                toast.error("لطفا شماره و رمز صحیح را وارد کنید !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
    };

    const onFinishFailed = (errorInfo) => {
        toast.error("لطفا شماره و رمز را وارد کنید !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            progress: undefined,
            theme: "colored",
            style: { fontFamily: "Vazir" },
        });
    };

    return (
        <>
            <Layout className="layout-default layout-signin">
                <Header>
                    <div className="header-col header-brand">
                        <h2>پنل ادمین پارکوپلو</h2>
                    </div>
                    {/* <div className="header-col header-nav">
                        <Menu mode="horizontal" defaultSelectedKeys={["1"]}>
                            <Menu.Item key="1">
                                <Link to="/sign-up">
                                    {signup}
                                    <span>ثبت نام</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="2">
                                <Link to="/sign-in">
                                    {signIn}
                                    <span>ورود</span>
                                </Link>
                            </Menu.Item>
                        </Menu>
                    </div> */}
                </Header>
                <Content
                    className="signin"
                    style={{
                        height: "90vh",
                    }}
                >
                    <Row gutter={[24, 0]} justify="space-around">
                        <Col
                            xs={{ span: 24, offset: 0 }}
                            lg={{ span: 6, offset: 2 }}
                            md={{ span: 12 }}
                        >
                            <Title className="mb-15">ورود به پنل ادمین</Title>
                            <Title
                                className="font-regular text-muted"
                                level={5}
                            >
                                برای ورود شماره و رمز خود را وارد کنید
                            </Title>
                            <Form
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                layout="vertical"
                                className="row-col"
                            >
                                <Form.Item
                                    className="username"
                                    label="شماره تلفن"
                                    name="email"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "لطفا شماره خود را وارد کنید!",
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="شماره تلفن"
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    className="username"
                                    label="رمز"
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "لطفا رمز خود را وارد کنید!",
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="رمز"
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ width: "100%" }}
                                    >
                                        ورود
                                    </Button>
                                </Form.Item>
                                {/* <p className="font-semibold text-muted">
                                    اکانت ندارید؟{" "}
                                    <Link
                                        to="/sign-up"
                                        className="text-dark font-bold"
                                    >
                                        ثبت نام
                                    </Link>
                                </p> */}
                            </Form>
                        </Col>
                        <Col
                            className="sign-img"
                            style={{ padding: 150 }}
                            xs={{ span: 24 }}
                            lg={{ span: 12 }}
                            md={{ span: 12 }}
                        >
                            <img src="../images/logo.svg" alt="logo" />
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </>
    );
}

export default SignIn;
